import { Image, View } from "@react-pdf/renderer";
import React from "react";
import { DEFAULT_LOGO_CONTAINER_HEIGHT, MAX_LOGO_HEIGHT, MAX_LOGO_WIDTH } from "../_defaults";
import { useDocumentContext } from "../context";
import { tw } from "../tailwind";

export function Logo() {
	/** Context */
	const context = useDocumentContext();

	const url = !context.logoUrl?.trim()
		? "https://placehold.co/400x400/jpg?text=No+Logo"
		: context.logoUrl;

	/** Render */
	return (
		<React.Fragment>
			<View
				fixed
				style={{
					...tw("flex flex-row justify-end"),
					height: `${DEFAULT_LOGO_CONTAINER_HEIGHT}px`,
				}}
			>
				<Image
					style={{
						objectFit: "contain",
						objectPosition: "right",
						height: `${MAX_LOGO_HEIGHT}px`,
						width: `${MAX_LOGO_WIDTH}px`,
					}}
					src={url}
				/>
			</View>
		</React.Fragment>
	);
}
